// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  Input,
} from '@angular/core';
import { CtsGantryStepStatusEType } from '../../enum/cts-gantry-step-status-type';
import { CtsGantryInitStepStatusService } from '../../services/cts-gantry-init-step-status.service';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: 'app-cts-gantry-functional-unit-step-tile',
  templateUrl: './cts-gantry-functional-unit-step-tile.component.html',
  styleUrl: './cts-gantry-functional-unit-step-tile.component.scss',
})
export class CtsGantryFunctionalUnitStepTileComponent {
  @Input({ required: true }) status: string =
    CtsGantryStepStatusEType.NOT_EXECUTED;
  @Input() isSuccessful: boolean = false;
  @Input() showStatusIcon: boolean = false;

  protected stepStatusService = inject(CtsGantryInitStepStatusService);
}
